import { getUserList, getReward } from '@/api/system.api.js'

import { mapMutations } from 'vuex'

export default {
  props: {
    giftData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      bindDialogVisible: false,
      giftLog: [],
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    isLogin() {
      return Object.keys(this.user).length > 0
    },
  },
  methods: {
    ...mapMutations(['setTipsDialog', 'setLoginDialog']),
    getGiftImg(icon) {
      return require('@/assets/img/common/gift/' + icon)
    },
    openReserveDialog() {
      this.$emit('reserve')
    },
    async openBindDialog() {
      if (!this.isLogin) {
        this.setLoginDialog({ visible: true })
        return false
      }

      const params = {
        token: this.user.token,
        type: 'down',
        game: 'tc',
      }
      const hasRole = await getUserList(params)
        .then((res) => {
          if (res.data.length <= 0) {
            return false
          }
          return true
        })
      if (!hasRole) {
        this.setTipsDialog({ visible: true, tips: '请先下载游戏并创建角色' })
        return false
      }

      this.giftLog = [{
        type: 6,
        id: 21,
        status: 0,
      }]

      this.$nextTick(() => {
        this.bindDialogVisible = true
      })
    },
  }
}